export default props => (
  <div className={`app-layout ${props.hasSider ? 'has-sider' : ''}`}>
    {props.children}
  </div>
)
